import { render, staticRenderFns } from "./TwDocuments.vue?vue&type=template&id=3a6d38c5&scoped=true&"
import script from "./TwDocuments.vue?vue&type=script&lang=js&"
export * from "./TwDocuments.vue?vue&type=script&lang=js&"
import style0 from "./TwDocuments.vue?vue&type=style&index=0&id=3a6d38c5&lang=scss&scoped=true&"
import style1 from "./TwDocuments.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6d38c5",
  null
  
)

export default component.exports